import React from 'react';

import CSFormUtil from "../util/CSFormUtil";

const mFormUtil         = CSFormUtil.cfGetInstance();
const mMaxSections      = 3;
const mMinSectionItems 	= 3;

const CSCODetailsSection = (lProps) =>
{
    const fnPopout = (lEvent, lFormItem) =>
    {
        if(lEvent && lFormItem && lProps.pOnPopout)
        {
            lProps.pOnPopout(lEvent, lFormItem);
        }
    }

    let lForm = null;
    let lMaxSections = (lProps.pNumSections) ? lProps.pNumSections : mMaxSections;
    let lMinSectionItems = mMinSectionItems;
    if(lProps.pFormItems && (lProps.pFormItems.length > 0))
    {
        let lFormCode = null;
        lFormCode = lProps.pFormItems[0].cs_form_code_;
        if(lProps.pFormProperties)
        {
            for(let pInd=0; pInd<lProps.pFormProperties.length; pInd++)
            {
                let lProperty = lProps.pFormProperties[pInd];
                if(lProperty && (lProperty.cs_form_code_ === lFormCode)) {
                    if(lProperty.property_ === 'max_sections_'){
                        lMaxSections = Number(lProperty.value_);
                    }
                    else if(lProperty.property_ === 'min_section_items_'){
                        lMinSectionItems = Number(lProperty.value_);
                    }
                }
            }
        }

        lForm = 
            <div className="fluid flex">
                { mFormUtil.cfGetSections(lProps.pFormItems, lMinSectionItems, lMaxSections, lProps.pProcessChange, null, null, null, fnPopout, true) }
            </div>
    }

    return lForm;
}

export default CSCODetailsSection;
